import React from 'react';
import UserCard from '../../../../generic/selectTable/userCard';
import { getDateTimeFormated } from '../../../../utils/dates/utils';
import { APPROVAL_DECISIONS } from '../../../../../redux/slices/LomavisPostApproval/constants';
import CheckStepStatus from './checkStepStatus';
import {useTranslate} from "@tolgee/react";

const UserInfoTimelineCard = ({ user }) => {
    const { t } = useTranslate();

  const checkDecision = (decision: boolean | null) => {
    if (decision === true) {
      return APPROVAL_DECISIONS.APPROVED;
    } else if (decision === false) {
      return APPROVAL_DECISIONS.REJECTED;
    } else {
      return APPROVAL_DECISIONS.EMPTY;
    }
  };
  return (
    <div className="row w-100 align-items-center">
      <div className="col-6 d-flex align-items-center justify-content-start">
        <UserCard item={user} />
      </div>
      <div className="col-4 d-flex align-items-center text-muted fs-7">
        {user?.timeStamp ? getDateTimeFormated(user?.timeStamp): t('lomavisPostApproval.statusHeader.notDecided') }
      </div>
      <div className="col-2 d-flex align-items-center">
        <CheckStepStatus status={checkDecision(user?.approval)} />
      </div>
    </div>
  );
};

export default UserInfoTimelineCard;
